var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKickstarter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 49.858C38.7287 49.858 49.858 38.7287 49.858 25C49.858 11.2714 38.7287 0.14209 25 0.14209C11.2714 0.14209 0.14209 11.2714 0.14209 25C0.14209 38.7287 11.2714 49.858 25 49.858Z",
    fill: "#2BDE73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5995 21.3815L27.0174 15.3428C27.8527 14.2051 28.9308 13.6362 30.2529 13.6362C31.3313 13.6362 32.2642 13.9971 33.0533 14.7191C33.8416 15.4412 34.2357 16.3054 34.2357 17.3119C34.2357 18.0558 34.0274 18.7123 33.6098 19.2812L29.6264 24.7456L34.4968 30.5711C34.9839 31.1509 35.2273 31.8294 35.2273 32.6059C35.2273 33.6345 34.845 34.5175 34.0794 35.2559C33.3141 35.9946 32.3859 36.3635 31.2964 36.3635C30.1019 36.3635 29.1919 35.9974 28.5654 35.2641L22.5995 28.2409V32.1138C22.5995 33.2189 22.3968 34.0774 21.9907 34.6901C21.2487 35.8056 20.1703 36.3635 18.7558 36.3635C17.4686 36.3635 16.471 35.9533 15.764 35.1329C15.103 34.378 14.7727 33.3768 14.7727 32.1302V17.7714C14.7727 16.5898 15.1085 15.6165 15.7814 14.8506C16.4886 14.0412 17.4625 13.6362 18.7033 13.6362C19.8862 13.6362 20.8717 14.0412 21.6602 14.8506C22.1008 15.299 22.3791 15.753 22.495 16.2125C22.5647 16.4972 22.5995 17.0274 22.5995 17.8043V21.3815Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKickstarter);
export default __webpack_public_path__ + "static/media/Kickstarter.50c5f476ba0e8b598d5d383dd79a88b1.svg";
export { ForwardRef as ReactComponent };